// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"36da3c1f","455":"a0b0addc","977":"827bbe1c"}[chunkId] + ".chunk.js";
};